import React from "react";
import PropTypes from "prop-types";

const Steps = ({ steps, step }) => (
    <ul className="Container-progessbar">
        {steps.map((item, index) => (
            <li key={index} className={index < step ? 'active' : ''}>
                {item}
            </li>
        ))}
    </ul>
); 

Steps.propTypes = {
    steps: PropTypes.arrayOf(PropTypes.string).isRequired,
    step: PropTypes.number.isRequired,
};

export default Steps;



// WEBPACK FOOTER //
// ./src/components/Steps.jsx